import { EMPLOYEE_ZONES_ALIASES } from 'domain/shared/employee';

export const getStatusByMonths = (months: number) => {
  if (months >= 7) {
    return EMPLOYEE_ZONES_ALIASES.CRITICAL;
  } else if (months >= 6) {
    return EMPLOYEE_ZONES_ALIASES.MONITORING;
  } else {
    return EMPLOYEE_ZONES_ALIASES.SAFE;
  }
};
